import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { AppUrls } from 'projects/bis-shared/src/lib/utility/appurls';
import { DraftEformsQueueComponent } from '../../eform-queues/draft-eforms-queue/draft-eforms-queue.component';
import { SubmittedEformsQueueComponent } from '../../eform-queues/submitted-eforms-queue/submitted-eforms-queue.component';
 
@Component({
  selector: 'app-medical-supplier-dashboard',
  templateUrl: './medical-supplier-dashboard.component.html',
  styleUrls: ['./medical-supplier-dashboard.component.scss'],
  imports: [
    MatCardModule,
    MatTabsModule,
    DraftEformsQueueComponent,
    SubmittedEformsQueueComponent,
  ],
})
export class MedicalSupplierDashboardComponent {
  selectedTabIndex: number;

  AppUrls = AppUrls;
  @Input() redirectToTabIndex: number;
}
